export const debounce = function (fn, delay, context) {
	let timeout;
	return function () {
		let args = arguments;

		context = context || this;

		clearTimeout(timeout);
		timeout = setTimeout(function () {
			timeout = null;
			fn.apply(context, args);
		}, delay);
	};
};

export const math = {
	lerp: (start, end, t) => {
		return (1 - t) * start + t * end;
	},
	norm: (value, min, max) => {
		return (value - min) / (max - min)
	},
	clamp: (num, min, max) => Math.min(Math.max(num, min), max),
	map: (value, in_min, in_max, out_min, out_max) => {
		return (value - in_min) * (out_max - out_min) / (in_max - in_min) + out_min
	}
}
